import axios from 'axios';
import { clearAuthToken, getAuthToken } from './authStorage';

/** ต้องมี http:// หรือ https:// — ถ้าไม่มีจะเติม https:// ให้ */
function normalizeApiBaseUrl(url) {
  const fallback = 'http://localhost:3001/api';
  const trimmed = (url || fallback).trim().replace(/\/$/, '');
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

const apiClient = axios.create({
  baseURL: normalizeApiBaseUrl(process.env.REACT_APP_API_URL),
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthToken();
      window.dispatchEvent(new Event('auth:logout'));
    }
    return Promise.reject(error);
  }
);

export default apiClient;
